export default function hasChanged<T>(data1: T, data2: T): boolean {
  return JSON.stringify(data1) !== JSON.stringify(data2);
}
